import { render, staticRenderFns } from "./NPCV4.vue?vue&type=template&id=37455983&scoped=true&"
import script from "./NPCV4.vue?vue&type=script&lang=js&"
export * from "./NPCV4.vue?vue&type=script&lang=js&"
import style0 from "./NPCV4.vue?vue&type=style&index=0&id=37455983&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37455983",
  null
  
)

export default component.exports